export default class Household {
  // Rol vivienda
  setHouseholdId(value) {
    this.householdId = value || '';
    return this;
  }

  // Moneda
  setCurrency(value) {
    this.currency = value || '';
    return this;
  }

  // País
  setCountry(value) {
    this.country = value || '';
    return this;
  }

  // Rut tasador
  setAppraiserIdNumber(value) {
    this.appraiserIdNumber = value || '';
    return this;
  }

  // Tipo cliente
  setClientType(value) {
    this.clientType = value || '';
    return this;
  }

  // Nombre conjunto
  setHousingComplexName(value) {
    this.housingComplexName = value || '';
    return this;
  }

  // Fecha escritura
  setSignatureDate(value) {
    this.signatureDate = value || '';
    return this;
  }

  // Nombre proyecto
  setProjectName(value) {
    this.projectName = value || '';
    return this;
  }

  // Dirección
  setAddress(value) {
    this.address = value || '';
    return this;
  }

  // Bloque
  setBlock(value) {
    this.block = value || '';
    return this;
  }

  // Número dpto
  setApartmentNumber(value) {
    this.apartmentNumber = value || '';
    return this;
  }

  // Villa
  setVilla(value) {
    this.villa = value || '';
    return this;
  }

  // Código postal
  setPostalCode(value) {
    this.postalCode = value || '';
    return this;
  }

  // Fecha construcción
  setBuiltDate(value) {
    this.builtDate = value || '';
    return this;
  }

  // M2 construidos
  setBuiltSqMts(value) {
    this.builtSqMts = value || '';
    return this;
  }

  // M2 terreno
  setLandSqMts(value) {
    this.landSqMts = value || '';
    return this;
  }

  // Número dpto. edificio
  setBuildingApartmentNumber(value) {
    this.buildingApartmentNumber = value || '';
    return this;
  }

  // Número dormitorios
  setNumberOfBedrooms(value) {
    this.numberOfBedrooms = value || '';
    return this;
  }

  // Número baños
  setNumberOfBathrooms(value) {
    this.numberOfBathrooms = value || '';
    return this;
  }

  // Nombre CBR
  setRealStateConservatorName(value) {
    this.realStateConservatorName = value || '';
    return this;
  }

  // Fecha inscripción CBR
  setRealStateConservatorInscriptionDate(value) {
    this.realStateConservatorInscriptionDate = value || '';
    return this;
  }

  // Rut notario
  setNotaryIdNumberWithoutVD(value) {
    this.notaryIdNumberWithoutVD = value || '';
    return this;
  }

  // DV notario
  setNotaryIdNumberVD(value) {
    this.notaryIdNumberVD = value || '';
    return this;
  }

  // Fojas dominio
  setDomainSheetNumber(value) {
    this.domainSheetNumber = value || '';
    return this;
  }

  // Número dominio
  setDomainNumber(value) {
    this.domainNumber = value || '';
    return this;
  }

  // Año dominio
  setDomainYear(value) {
    this.domainYear = value || '';
    return this;
  }

  // Núm. inscripción
  setInscriptionNumber(value) {
    this.inscriptionNumber = value || '';
    return this;
  }

  // Valor tasación
  setAppraisalValue(value) {
    this.appraisalValue = value || '';
    return this;
  }

  // Fecha tasación
  setAppraisalDate(value) {
    this.appraisalDate = value || '';
    return this;
  }

  // Número cert. recep. municipal
  setMunicipalReceptionCertificateNumber(value) {
    this.municipalReceptionCertificateNumber = value || '';
    return this;
  }

  // Fecha recepción municipal
  setMunicipalReceptionDate(value) {
    this.municipalReceptionDate = value || '';
    return this;
  }

  // Avalúo fiscal
  setTaxAppraisal(value) {
    this.taxAppraisal = value || '';
    return this;
  }

  // Valor liquidación
  setLiquidationValue(value) {
    this.liquidationValue = value || '';
    return this;
  }

  // Descripción
  setDescription(value) {
    this.description = value || '';
    return this;
  }

  // Rut propietario
  setOwnerIdNumberWithoutVD(value) {
    this.ownerIdNumberWithoutVD = value || '';
    return this;
  }

  // DV propietario
  setOwnerIdNumberVD(value) {
    this.ownerIdNumberVD = value || '';
    return this;
  }

  // Nombre propietario
  setOwnerName(value) {
    this.ownerName = value || '';
    return this;
  }

  // Propietario vive en vivienda
  setOwnerLivesAtHousehold(value) {
    this.ownerLivesAtHousehold = value || '';
    return this;
  }

  // Comuna vivienda
  setHouseholdCommune(value) {
    this.householdCommune = value || '';
    return this;
  }

  // Tipo propiedad
  setPropertyType(value) {
    this.propertyType = value || '';
    return this;
  }

  // Tipo vivienda
  setHouseholdType(value) {
    this.householdType = value || '';
    return this;
  }

  // Destino vivienda
  setHouseholdDestination(value) {
    this.householdDestination = value || '';
    return this;
  }

  // Vigencia
  setValidity(value) {
    this.validity = value || '';
    return this;
  }

  // Estado propiedad
  setPropertyStatus(value) {
    this.propertyStatus = value || '';
    return this;
  }

  // Tipo construcción
  setConstructionType(value) {
    this.constructionType = value || '';
    return this;
  }

  // Estado vivienda
  setHouseholdStatus(value) {
    this.householdStatus = value || '';
    return this;
  }

  // Valor compraventa
  setPurchaseValue(value) {
    this.purchaseValue = value || '';
    return this;
  }

  // Valor terreno
  setLandValue(value) {
    this.landValue = value || '';
    return this;
  }

  // Estado asociación
  setAssociationStatus(value) {
    this.associationStatus = value || '';
    return this;
  }

  // Valor pie
  setDownPaymentValue(value) {
    this.downPaymentValue = value || '';
    return this;
  }
}
